import { Text } from '@sendoutcards/quantum-design-ui'
import React, { FC, ReactNode, Suspense } from 'react'
import { ErrorBoundary } from 'src/chrome'

export type SuspenseBoundaryProps = {
  unresolved: NonNullable<ReactNode>
  failure: (error: Error) => NonNullable<ReactNode>
}

export const DefaultError = (error: Error) => (
  <div
    style={{
      height: '100%',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'white',
    }}
  >
    <div>
      <Text type="title" color="danger" alignment="center">
        {error.message}
      </Text>
    </div>
  </div>
)

const SuspenseBoundary: FC<SuspenseBoundaryProps> = ({
  unresolved,
  failure,
  children,
}) => (
  <Suspense fallback={unresolved}>
    <ErrorBoundary fallback={failure}>{children}</ErrorBoundary>
  </Suspense>
)

export default SuspenseBoundary
